/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcodetreeid3Inputs */

const en_entity_contactcodetreeid3 = /** @type {(inputs: Entity_Contactcodetreeid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Code Tree ID`)
};

const de_entity_contactcodetreeid3 = /** @type {(inputs: Entity_Contactcodetreeid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Code-Baum-ID`)
};

/**
* | output |
* | --- |
* | "Contact Code Tree ID" |
*
* @param {Entity_Contactcodetreeid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcodetreeid3 = /** @type {((inputs?: Entity_Contactcodetreeid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcodetreeid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcodetreeid3(inputs)
	return de_entity_contactcodetreeid3(inputs)
});
export { entity_contactcodetreeid3 as "entity_contactCodeTreeId" }